import providerInstance from "../api-provider";
import handleError from "../handleError";

export const getIVRCalls = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/ivr/getIVRCalls",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getIVRCallList = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/ivr/getIVRCallList",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getIVRCallNotes = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/ivr/getIVRCallNotes",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const addIVRCallNote = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/ivr/addIVRCallNote",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getRecentCallsByCaller = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/ivr/getRecentCallsByCaller",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getIVRCallReasonCodes = async (token) => {
  try {
    let response = await providerInstance({
      url: "/ivr/getIVRCallReasonCodes",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateIVRCall = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/ivr/updateIVRCall",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getIVRSummaryCounts = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/ivr/getIVRSummaryCounts",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getIVRCallAudio = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/ivr/getIVRCallAudio",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "arraybuffer",
      data: payload,
    });
    const mimeType = response.headers["content-type"];
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: mimeType })
    );
    return url;
    //return response.data;
  } catch (error) {
    handleError(error);
  }
};
export const deleteIVRCall = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/ivr/deleteIVRCall",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
